module.exports = __webpack_public_path__ + "media/images/front/banner_seminar20180729_2-8e071455050cc20fe5f35e46a0f1113e.jpg";